module.exports = __webpack_public_path__ + "img/star_shape.be5030ca.webp";